export const GENRE_LABELS = {
  'Action':        'Acción',
  'Adventure':     'Aventura',
  'Avant Garde':   'Avant Garde',
  'Award Winning': 'Premiado',
  'Boys Love':     'Boys Love',
  'Comedy':        'Comedia',
  'Drama':         'Drama',
  'Ecchi':         'Ecchi',
  'Erotica':       'Erótica',
  'Fantasy':       'Fantasía',
  'Girls Love':    'Girls Love',
  'Gourmet':       'Gourmet',
  'Hentai':        'Hentai',
  'Horror':        'Terror',
  'Mystery':       'Misterio',
  'Romance':       'Romance',
  'Sci-Fi':        'Ciencia Ficción',
  'Slice of Life': 'Slice of Life',
  'Sports':        'Deportes',
  'Supernatural':  'Sobrenatural',
  'Suspense':      'Suspenso',
};

export const THEME_LABELS = {
  'Gore':           'Gore',
  'Harem':          'Harem',
  'Historical':     'Histórico',
  'Isekai':         'Isekai',
  'Martial Arts':   'Artes Marciales',
  'Mecha':          'Mecha',
  'Military':       'Militar',
  'Music':          'Música',
  'Parody':         'Parodia',
  'Psychological':  'Psicológico',
  'Reincarnation':  'Reencarnación',
  'Reverse Harem':  'Harem Inverso',
  'Samurai':        'Samurai',
  'School':         'Escolar',
  'Space':          'Espacio',
  'Super Power':    'Superpoderes',
  'Survival':       'Supervivencia',
  'Time Travel':    'Viaje en el Tiempo',
  'Vampire':        'Vampiro',
};

const ALL_LABELS = { ...GENRE_LABELS, ...THEME_LABELS };

export const genreLabel = (v) => ALL_LABELS[v] || v;
